/**
 * @description: 项目入口文件
 * @author: nowThen
 */

import Vue from 'vue';
import App from './App.vue';
import router from './routers/';
import './routers/intercept';
import store from './stores';
import * as filters from './filters/';
import './services';
import 'lib-flexible';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { Image as VanImage, ActionSheet } from 'vant';

import './styles/main.less';

import VueLazyload from 'vue-lazyload'
import MetaInfo from 'vue-meta-info'

import topImg from '@/component/topImg';

Vue.use(ElementUI);
Vue.use(MetaInfo);
Vue.use(VanImage);
Vue.use(ActionSheet);
Vue.use(VueLazyload, {
  preLoad: 1.5 })

// import FastClick from 'fastclick';

// FastClick.attach(document.body);

Vue.config.errorHandler = (err, vm, info) => {
  console.error(err);
};

// import VConsole from 'vconsole'
// new VConsole();

Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.config.productionTip = process.env.NODE_ENV === 'production';

window.EventBus = new Vue();

// 注册过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.component('topImg', topImg)

window.myVue = new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event('render-event'))
}).$mount('#app')
